import { ReactComponent as JUG } from "../../customIcons/Jug.svg";
import { ReactComponent as D30 } from "../../customIcons/Drum30.svg";
import { ReactComponent as D55 } from "../../customIcons/Drum55.svg";
import { ReactComponent as TOTE } from "../../customIcons/Tote.svg";
import { ReactComponent as PFC } from "../../customIcons/PFC.svg";
import { ReactComponent as B50 } from "../../customIcons/Bag50.svg";
import { ReactComponent as B40 } from "../../customIcons/Bag40.svg";
import { ReactComponent as B30 } from "../../customIcons/Bag30.svg";
import { ReactComponent as B25 } from "../../customIcons/Bag25.svg";
import { ReactComponent as TR } from "../../customIcons/ToteRefill.svg";
import { ReactComponent as GAL } from "../../customIcons/GAL.svg";
import { ReactComponent as LBS } from "../../customIcons/LBS.svg";
import { ReactComponent as PAIL } from "../../customIcons/Pail.svg";
import { ReactComponent as GALJUG } from "../../customIcons/GalJug.svg";
import { ReactComponent as AREA } from "../../customIcons/Acerage.svg";
import { ReactComponent as TON } from "../../customIcons/Ton.svg";

import { ReactComponent as TANK } from "../../customIcons/Tanks4.svg";

import {Button, Dialog, DialogBackdrop, DialogPanel, DialogTitle, Input, Select} from "@headlessui/react";
import React, {useEffect, useState} from "react";
import {XMarkIcon} from "@heroicons/react/16/solid";
import {useDarkMode} from "../../contexts/darkModeContext";
import {
    BanknotesIcon,
    ExclamationTriangleIcon,
    LockClosedIcon,
    PencilIcon, TrashIcon, XCircleIcon,
} from "@heroicons/react/24/outline";
import {ADLProducts, UMMapping, warehouseOptions} from "../GLOBAL/GlobalFunctions";
import TANKIcons from "../Widgets/TANKIcons";
import UMIcons from "../Widgets/UMIcons";
import {calculateDiscountedTotal} from "./OrderFunctions";
import StepperInput from "./StepperInput";

const ProductInput = ({ accountLevel, index, blank, UniqueKey, onRemove, onAdd, product, priceType, discount, isBulk, contractPrices, region, lineItem, tankLocations, early, prepay, state }) => {
    const isPromotional = (product?.category || lineItem?.category) === 'Promotional Item';
    const promotionalImageUrl = product?.promotionalImageUrl || lineItem?.promotionalImageUrl || '';
    
    const [id] = useState(lineItem?.id || product?.id);
    const [price, setPrice] = useState( lineItem?.price || 0);
    const [orginalPrice, setOrginalPrice] = useState(0);
    const [quantity, setQuantity] = useState(lineItem?.quantity || '1');
    const [productCode, setProductCode] = useState( lineItem?.productCode || "");
    const [total, setTotal] = useState((price * quantity).toFixed(2));
    const [actualTotal, setActualTotal] = useState(0);
    const [selectedVolume, setSelectedVolume] = useState(lineItem?.selectedVolume || product?.prices[0].um); // Set to the first `um` in prices or an empty string if prices is empty
    const [name, setName] = useState(lineItem?.name || "");
    const [uniqueKey] = useState(lineItem?.uniqueKey || UniqueKey || "");
    
    const [bulkCode] = useState(lineItem?.bulkCode || product?.BULKCODE || "");
    
    const [blankItem] = useState(lineItem?.blankItem || blank);
    
    const [edit, setEdit] = useState(lineItem?.edit || false);
    
    const [tankLocals, setTankLocals] = useState(lineItem?.tankLocals || []);
    
    const [lock] = useState(isPromotional ? false : (!!lineItem?.lock || !!product?.lock || false));
    
    const [warehouse, setWarehouse] = useState(lineItem?.warehouse || "MAIN");
    const [disabled, setDisabled] = useState(false);
   
    const [discountAmount, setDiscountAmount] = useState(0);
    const [manualDiscount, setManualDiscount] = useState(false);
    
    // frozen initial value (does NOT change)
    const initialDiscount = lineItem?.discountAmount ?? discount ?? 0;


    const [unitLabel, setUnitLabel] = useState("Quant");
    const [contract, setContract] = useState(false);
    
    
    const [isNoCharge, setIsNoCharge] = useState(lineItem?.isNoCharge || false);  // Initial state based on defaultChecked
    const [reasonCode, setReasonCode] = useState(lineItem?.reasonCode || "DONATE");
    
    
    useEffect(() => {
        if (!lineItem?.warehouse) {
            if (region === "SE" && ADLProducts[productCode]) {
                setWarehouse(ADLProducts[productCode]);  // Set warehouse to ADL if productCode matches
                console.log('warehouse');
            } else {
                setWarehouse("MAIN");  // Default to MAIN if region is not SE or productCode is not in ADLProducts
                console.log('warehouse');
            }
        }
        
        console.log('warehouse');
        // eslint-disable-next-line
    }, [productCode, region]);  // Re-run the effect whenever productCode or region changes
    

    const { darkMode } = useDarkMode();

    
    const [isDiscountApplied, setDiscountApplied] = useState(false);
    const [isDiscountDisplayed, setDiscountDisplayed] = useState(false);
    
   
useEffect(() => {
    const baseTotal = price * quantity;

    // 🔍 DERIVE CONTRACT IN REAL-TIME (prevents timing issues)
    const contractPriceEntry = contractPrices?.find((c) => {
        const contractCode = String(c.productCode).trim().toUpperCase();
        const priceCode = String(productCode).trim().toUpperCase();
        const volumeMatch = String(c.selectedVolume) === String(selectedVolume);
        return contractCode === priceCode && volumeMatch;
    });

    const isContractActive = contract || (!!contractPriceEntry && !contractPriceEntry.percent);
    const isContractPercent = !!contractPriceEntry && contractPriceEntry.percent;

    // 🏆 CONTRACT ALWAYS WINS (even over UM rules)
    if (isContractActive) {
        setDiscountAmount(0);
        setDiscountApplied(false);
        setDiscountDisplayed(false);
        setTotal(baseTotal.toFixed(2));
        setActualTotal(baseTotal.toFixed(2));
        return;
    }

    // 🚫 UM RULE → disable discount for GAL, TON (ONLY if NOT contract OR contract percent)
    if (
        ["GAL", "TON"].includes(selectedVolume) &&
        !isContractPercent &&
        !isBulk
    ) {
        setDiscountAmount(0);
        setDiscountApplied(false);
        setDiscountDisplayed(false);
        setTotal(baseTotal.toFixed(2));
        setActualTotal(baseTotal.toFixed(2));
        return;
    }
    
    // if (["GAL", "TON"].includes(selectedVolume) && !isContractPercent) {
    //     setDiscountAmount(0);
    //     setDiscountApplied(false);
    //     setDiscountDisplayed(false);
    //     setTotal(baseTotal.toFixed(2));
    //     setActualTotal(baseTotal.toFixed(2));
    //     return;
    // }
    

    // 🔒 LOCKED → no discount allowed (contract already handled above)
    if (lock) {
        setDiscountAmount(0);
        setDiscountApplied(false);
        setDiscountDisplayed(false);
        setTotal(baseTotal.toFixed(2));
        setActualTotal(baseTotal.toFixed(2));
        return;
    }

    let finalDiscount = 0;

    // 🥇 1. MANUAL (user typed)
    if (manualDiscount) {
        finalDiscount = discountAmount || 0;
    }

    // 🥈 2. LINE ITEM (editing existing order)
    else if (lineItem?.discountAmount > 0) {
        finalDiscount = lineItem.discountAmount;
    }

    // 🥉 3. INITIAL PROP (incoming from parent)
    else if (initialDiscount > 0) {
        finalDiscount = initialDiscount;
    }

    // 🧪 4. AUTO LOGIC (fallback only)
    
    // 🧪 4. AUTO LOGIC (fallback only)
    else {
        const isBulkUM =
            selectedVolume === "GAL" ||
            selectedVolume === "TON";
    
        if (isBulk) {
            // Bulk customers only get discounts on GAL and TON
            if (isBulkUM) {
                finalDiscount = discount || 0;
            }
        } else {
            // Non-bulk customers get discounts on everything EXCEPT GAL and TON
            if (!isBulkUM) {
                finalDiscount = discount || 0;
            }
        }
    }
    
    // else {
    //     const isAG = priceType === "AG";
    //     const isGAL = selectedVolume === 'GAL' || selectedVolume === 'TON';
    //
    //     if ((isAG && isGAL) || (!isAG && !isGAL)) {
    //         finalDiscount = discount || 0;
    //     }
    // }
    
    const isBulkUM =
        selectedVolume === "GAL" ||
        selectedVolume === "TON";
    
    // Final enforcement of bulk rules
    if (isBulk) {
        // Bulk customers ONLY get discounts on GAL/TON
        if (!isBulkUM) {
            finalDiscount = 0;
        }
    } else {
        // Non-bulk customers NEVER get discounts on GAL/TON
        if (isBulkUM) {
            finalDiscount = 0;
        }
    }

    const discountedTotal = (baseTotal * (1 - finalDiscount / 100)).toFixed(2);

    setDiscountApplied(finalDiscount > 0);
    setDiscountDisplayed(finalDiscount > 0);

    // only sync state if NOT manual
    if (!manualDiscount) {
        setDiscountAmount(finalDiscount);
    }

    setActualTotal(baseTotal.toFixed(2));
    setTotal(discountedTotal);

}, [
    price,
    quantity,
    selectedVolume,
    discount,
    lineItem?.discountAmount,
    lock,
    contract,
    priceType,
    manualDiscount,
    discountAmount,
    productCode,
    isBulk,
    contractPrices
]);
    
    const handleDiscountChange = (e) => {
        const val = parseFloat(e.target.value);
        setManualDiscount(true);
        setDiscountAmount(isNaN(val) ? 0 : val);
    };
    
    
    
    useEffect(() => {
        setManualDiscount(false);
    }, [priceType, selectedVolume]);
    
    
    const getPriceBasedOnSelection = (prices, priceType, quantity) => {
        // Ensure prices is an array
        if (!Array.isArray(prices)) {
            console.error("Prices must be an array");
            return 0;
        }

        // Convert priceType to lowercase to handle case insensitivity
        const normalizedPriceType = priceType.toLowerCase();

        // Find the price object where 'um' matches the specified quantity
        const priceObject = prices.find((price) => price.um === quantity);

        if (priceObject && priceObject[normalizedPriceType]) {
            return priceObject[normalizedPriceType];
        }

        return 0;
    };


    useEffect(() => {
        setIsLoaded(true);
        console.log('loaded');
    }, []);

    const [isLoaded, setIsLoaded] = useState(false); // State to track when the component is loaded
    const [isRemoving, setIsRemoving] = useState(false); // Track whether the item is being removed

    // Handle the remove action with animation
    const handleRemove = () => {
        console.log("Removing Key:", uniqueKey);
        setIsRemoving(true);
        setTimeout(() => {
            onRemove(uniqueKey);
            setIsRemoving(false); // clean up if needed
        }, 500);
    };

    const [priceLimited, setPriceLimited] = useState(false);
    
    const [SelectedComponent, setSelectedComponent] = useState(null); // This will store the component itself
    const sharedClassName = `size-8 ${disabled ? 'text-red-600' : ''} ${contract ? 'text-yellow-600' : ''} ${isDiscountDisplayed ? 'text-blue-600' : ''}`; // You can also move this to Tailwind config if reused widely
    
    
    useEffect(() => {
        if (!product || !priceType || !selectedVolume) return;
    
        if (!blankItem) {
            setName(product.name);
        }
    
        const prices = product.prices || [];
        const priceObject = prices.find((price) => price.um === selectedVolume);
        const newPrice = getPriceBasedOnSelection(prices, priceType, selectedVolume);
    
        if (priceObject?.code) {
            setProductCode(priceObject.code);
            console.log("Selected Price Code:", priceObject.code);
        }
    
        const contractPriceEntry = contractPrices.find((contract) => {
            const contractCode = String(contract.productCode).trim().toUpperCase();
            const priceCode = String(productCode).trim().toUpperCase();
            const volumeMatch = String(contract.selectedVolume) === String(selectedVolume);
            return contractCode === priceCode && volumeMatch;
        });
    
        if (edit) {
            const linePrice = lineItem?.price || 0;
            setPrice(linePrice);
            console.log("Price set to line item price due to edit mode:", linePrice);
        } else if (isNoCharge) {
            setPrice(0);
            setContract(false);
            console.log("Price set to 0 due to no charge condition");
        } else if (contractPriceEntry) {
            if (contractPriceEntry.percent) {
                setDiscountAmount(contractPriceEntry.newValue);
                setManualDiscount(true); // set manual since it's a user-level contract %
                console.log("Discount applied from contract:", contractPriceEntry.newValue);
            } else {
                const contractPrice = contractPriceEntry.newValue || 0;
                setPrice(contractPrice);
                setContract(true);
                setPriceLimited(false);
                setDiscountAmount(0);
                setManualDiscount(false); // auto pricing
                console.log("Contract price applied:", contractPrice);
            }
        } else {
            const fallbackPrice = newPrice || 0;
            setPrice(fallbackPrice);
            setOrginalPrice(fallbackPrice);
            setContract(false);
            setPriceLimited(false);
            // setDiscountAmount(0);
            setManualDiscount(false);
            console.log("Standard price applied:", fallbackPrice);
        }
    
        const isDisabled = !isPromotional && !contractPriceEntry && (!newPrice || isNaN(newPrice) || newPrice === 0 || newPrice === "0");
        setDisabled(isDisabled);
    
        // handle quantity/unit defaults
        const volumeMap = {
            "2.5": { component: JUG, unit: "#", quantity: lineItem?.quantity || 1 },
            "30": { component: D30, unit: "#", quantity: lineItem?.quantity || 1 },
            "55": { component: D55, unit: "#", quantity: lineItem?.quantity || 1 },
            "275": { component: TOTE, unit: "#", quantity: lineItem?.quantity || 1 },
            "TR": { component: TR, unit: "gal", quantity: lineItem?.quantity || 100 },
            "GAL": { component: GAL, unit: "gal", quantity: lineItem?.quantity || 600 },
            "B50": { component: B50, unit: "#", quantity: lineItem?.quantity || 1 },
            "B40": { component: B40, unit: "#", quantity: lineItem?.quantity || 1 },
            "B30": { component: B30, unit: "#", quantity: lineItem?.quantity || 1 },
            "B25": { component: B25, unit: "#", quantity: lineItem?.quantity || 1 },
            "LB": { component: LBS, unit: "lbs", quantity: lineItem?.quantity || 1 },
            "PAI": { component: PAIL, unit: "#", quantity: lineItem?.quantity || 1 },
            "CS4": { component: GALJUG, unit: "#", quantity: lineItem?.quantity || 1 },
            "TON": { component: TON, unit: "tons", quantity: lineItem?.quantity || 1 },
            
            "0.25ACR": { component: AREA, unit: "ACRE", quantity: lineItem?.quantity || 1 },
            "0.5ACR": { component: AREA, unit: "ACRE", quantity: lineItem?.quantity || 1 },
            "0.75ACR": { component: AREA, unit: "ACRE", quantity: lineItem?.quantity || 1 },
            "1ACR": { component: AREA, unit: "ACRE", quantity: lineItem?.quantity || 1 },
            "1.25ACR": { component: AREA, unit: "ACRE", quantity: lineItem?.quantity || 1 },
            "1.5ACR": { component: AREA, unit: "ACRE", quantity: lineItem?.quantity || 1 },
            "2ACR": { component: AREA, unit: "ACRE", quantity: lineItem?.quantity || 1 },
        };
    
        const volumeData = volumeMap[selectedVolume];
    
        if (volumeData) {
            setSelectedComponent(volumeData.component);
            setUnitLabel(volumeData.unit);
            setQuantity(volumeData.quantity);
        } else {
            setSelectedComponent(PFC);
            setUnitLabel("#");
        }
    
        console.log("✅ Price recalculated");
    
    }, [product, priceType, productCode, selectedVolume, contractPrices, isNoCharge, edit, lineItem, blankItem, isPromotional]);
    
    
    const handleVolumeChange = (e) => {
        setSelectedVolume(e.target.value);
    };

    const numberWithCommas = (number) => {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    
    const handlePriceChange = (e) => {
        let inputPrice = parseFloat(e.target.value);
        setPrice(inputPrice || 0); // Simply update the price without validation here
        setEdit(true);
    };
    
    const handlePriceBlur = () => {
        const discountPercentage = 15;
        let inputPrice = parseFloat(price) || 0;
        const minPrice = orginalPrice * (1 - discountPercentage / 100); // 15% off the preloaded price
    
        if (inputPrice < minPrice) {
            setPriceLimited(true);
            setPrice(minPrice.toFixed(2) || 0); // Adjust price if it's below the minimum
            setEdit(true);
        } else {
            setPriceLimited(false);
        }
    };
    

    // Automatically pass data back to the parent whenever any key state changes
    useEffect(() => {
        const productData = {
            price,
            name,
            id,
            quantity,
            productCode,
            total,
            actualTotal,
            selectedVolume,
            warehouse,
            discountAmount,
            isNoCharge,
            isBulk,
            reasonCode,
            contract,
            lock,
            edit,
            disabled,
            uniqueKey,
            blankItem,
            tankLocals,
            bulkCode,
            category: product?.category || lineItem?.category || '',
            promotionalImageUrl,
        };
        onAdd(index, productData); // Automatically pass the product data to the parent
        
        console.log('added');
            // eslint-disable-next-line
    }, [price, name, quantity, productCode, total, selectedVolume, warehouse, actualTotal, discountAmount, discount, index, isNoCharge, reasonCode, id, contract, edit, lock, disabled, blankItem, tankLocals, bulkCode, product, lineItem, promotionalImageUrl]);
    

    const filteredWarehouses = warehouseOptions.filter(option => option.regions.includes(region));

    const [showConfirm, setShowConfirm] = useState(false);

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        if (checked) {
          // Instead of setting immediately, ask for confirmation
          setShowConfirm(true);
        } else {
          // Unchecking just updates immediately
          setIsNoCharge(false);
        }
    };
    
    const confirmCheck = () => {
        setIsNoCharge(true);
        setShowConfirm(false);
    };
    
    const cancelCheck = () => {
        setIsNoCharge(false);
        setShowConfirm(false);
    };

    
    
    
    
    
    const [tankExpanded, setTankExpanded] = useState(false);
    
    // Handle selection of a tank
    const handleSelectChange = (e) => {
        const selectedTankName = e.target.value;
        const selectedTank = tankLocations.find(tank => tank.label === selectedTankName);
    
        // Add selected tank to tankLocals array if not already selected
        if (selectedTank && !tankLocals.some(tank => tank.label === selectedTankName)) {
            setTankLocals([
                ...tankLocals,
                {
                    label: selectedTank.label,
                    type: selectedTank.type,
                    capacity: selectedTank.max,
                    unit: selectedTank.unit,
                    quantity: "", // default quantity
                },
            ]);
        }
    };
    
    // Handle removing a tank from the tankLocals list
    const handleRemoveTank = (tankName) => {
        setTankLocals(tankLocals.filter(tank => tank.label !== tankName));
    };
    
    // Handle quantity change for a tank
    const handleQuantityChange = (label, newQuantity) => {
        setTankLocals(prev =>
            prev.map(tank =>
                tank.label === label
                    ? { ...tank, quantity: Number(newQuantity) }
                    : tank
            )
        );
    };
    
    
    
    
    
    return (
        <div className={`w-full font-sans grid grid-cols-1 gap-x-3 border-b-2 ${blankItem ? 'border-cyan-600 border-dotted' : ''} ${darkMode ? 'border-darkBgColor text-white' : 'text-black'} ${isRemoving ? 'transform animate-slideOutLeft' : ''} mb-1.5 p-1 pb-0.5 transition-transform duration-500 ease-in-out ${isLoaded ? '' : 'translate-x-full opacity-0'}`}>

            {/* Header */}
            <div className={`col-span-1 grid grid-cols-6 gap-x-3`}>
                
                {/*PRODUCT NAME*/}
                <div className="col-span-1 flex flex-row items-center">
                    
                    {/*Icon*/}
                    <div className={`relative z-10 flex h-10 shrink-0 flex-col mt-auto mb-auto mr-2 overflow-visible ${isPromotional ? 'w-11' : 'w-11'}`}>
                        
                            
                            <div className="w-fit mr-auto ml-auto p-1.5 rounded-lg flex items-center justify-center">
                                {isPromotional && promotionalImageUrl ? (
                                  <img
                                      src={promotionalImageUrl}
                                      alt={name || 'Promotional item'}
                                      className="absolute left-0 top-1/2 size-12 -translate-y-1/2 rounded-lg object-cover"
                                  />
                                ) : SelectedComponent ? (
                                  <SelectedComponent className={sharedClassName} />
                                ) : (
                                  <PFC className={sharedClassName} />
                                )}
                            </div>
                        
                    
                    
                    </div>
                    
                    {/*Name and Product Code*/}
                    <div className="flex flex-col mt-auto mb-auto w-full">
                        {/*Scrollable Name by Hover*/}
                        <div ref={(container) => {
                            if (container) {
                                    const textElement = container.querySelector('.scrollable-text');
                                    if (textElement) {
                                        container.classList.toggle(
                                            'hover-enabled',
                                            textElement.scrollWidth > container.offsetWidth
                                        );
                                    }
                                }
                            }}
                            className={`${blankItem ? 'hidden' : ''} relative overflow-hidden ${disabled ? 'text-red-600' : ''}  text-sm font-medium w-full`}
                        >
                            <div className="scrollable-text inline-block whitespace-nowrap transition-transform duration-1000 ease-linear"
                                style={{
                                    transform: 'translateX(0)',
                                }}
                                onMouseEnter={(e) => {
                                    const container = e.currentTarget.parentElement;
                                    if (container.classList.contains('hover-enabled')) {
                                        e.currentTarget.style.transform = 'translateX(-50%)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateX(0)';
                                }}
                            >
                                {/*{discountAmount}*/}
                                {name}
                            </div>
                        </div>
                        <div className={`${blankItem ? 'hidden' : ''} ml-3 text-xxs ${darkMode ? 'text-borderColor' : 'text-borderColor'}`}>{productCode}</div>
                        
                        
                        {/*Name Input*/}
                        <div className={`mb-1 ${blankItem ? '' : 'hidden'} border-b ${darkMode ? 'border-neutral-700' : ''} ${disabled ? 'border border-red-600 rounded-lg' : ''} relative flex flex-row px-2 h-full items-center justify-center`}>
                            <Input
                                className={`rounded-md bg-transparent text-xs focus:outline-none p-0.5 w-full ${darkMode ? 'text-white' : 'text-black'}`}
                                type="string"
                                placeholder={`Enter Product Name`}
                                value={name}
                                disabled={!blankItem}
                                onChange={(event) => setName(event.target.value)} // Update priceType on selection change
                                // onChange={} // This will still allow live input, but without validation
                            />
                        </div>
                        
                        {/*Code Input*/}
                        <div className={`${blankItem ? '' : 'hidden'} border-b ${darkMode ? 'border-neutral-700' : ''} ${disabled ? 'border border-red-600 rounded-lg' : ''} relative flex flex-row px-2 h-full items-center justify-center`}>
                            <Input
                                className={`rounded-md bg-transparent text-xs focus:outline-none p-0.5 w-full ${darkMode ? 'text-white' : 'text-black'}`}
                                type="string"
                                placeholder={`Enter Product Description`}
                                value={productCode}
                                onChange={(event) => setProductCode(event.target.value)} // Update priceType on selection change
                                // onChange={} // This will still allow live input, but without validation
                            />
                        </div>
                        
                        
                    </div>
                    
                </div>
    
                {/*PRODUCT PRICING/QUANT WH DISC*/}
                <div className="col-span-4 grid grid-cols-8 gap-x-2">
    
                    {/*PRICE*/}
                    <div className={`relative col-span-2 py-2.5`}>
                        <div className={`border ${darkMode ? 'border-neutral-700' : ''} ${disabled ? 'border border-red-600 rounded-lg' : ''} relative flex flex-row px-2 rounded-lg h-full items-center justify-center`}>
    
                            <BanknotesIcon className={`size-6 mr-2 text-red-600 animate-heartbeat ${disabled ? '' : 'hidden'}`}/>
                            <div className={`text-borderColor text-md`}>$</div>
                            
                            <Input
                                className={`rounded-md bg-transparent text-sm focus:outline-none p-1.5 w-full ${darkMode ? 'text-white' : 'text-black'}`}
                                type="number"
                                placeholder={(price === 0 || !price) && !disabled ? 'No Book Price Enter Price' : 'No'}
                                value={price}
                                disabled={contract || isNoCharge || lock}
                                onChange={handlePriceChange} // This will still allow live input, but without validation
                                onBlur={handlePriceBlur} // Validation happens when input loses focus
                            />
                            
                            <div className={`text-gray-500 font-bold text-xxs`}>{disabled ? 'Request' : 'USD'}</div>
    
                        </div>
                        <div className={`absolute top-1 right-0`}>
                            <div className={`${contract ? 'hidden' : ''} ${lock ? 'hidden' : ''} ${edit ? 'hidden' : ''} flex-none rounded-full p-1 ${disabled ? 'bg-red-500/40 animate-heartbeat' : 'bg-emerald-500/30 animate-rubberBand-delay'}`}>
                              <div className={`size-2 rounded-full ${disabled ? 'bg-red-400' : 'bg-emerald-500'}`} />
                            </div>
                        </div>
    
                        {contract && (
                            <div className={`absolute top-1 right-0`}>
                                <div className={`flex-none rounded-full p-1 bg-yellow-500/30 animate-rubberBand-delay`}>
                                    <div className={`size-2 rounded-full bg-yellow-500`}/>
                                </div>
                            </div>
                        )}
                        
                        {lock && (
                            <div className={`absolute top-1 right-0`}>
                                <div className={`flex-none rounded-full animate-rubberBand-delay`}>
                                    <LockClosedIcon className={`size-4 stroke-2 rounded-full text-slate-500`}/>
                                </div>
                            </div>
                        )}
                        
                        {edit && (
                            <div className={`absolute top-1 right-0`}>
                                <div className={`flex-none rounded-full animate-rubberBand-delay`}>
                                    <PencilIcon className={`size-4 stroke-2 text-blue-500`}/>
                                </div>
                            </div>
                        )}
    
                    </div>
                    
                    {/*QUANTITY*/}
                    <div className={`relative col-span-2 py-2.5`}>
                        <div className={`border ${darkMode ? 'border-neutral-700' : ''} ${disabled ? 'border border-red-600 rounded-lg' : ''} flex flex-row px-4 rounded-lg h-full items-center justify-center hover:scale-y-105`}>
                            {/*// When quantity changes, trigger the onChange for recalculation*/}
                            <Input
                                className={`rounded-md bg-transparent text-sm focus:outline-none p-1.5 w-full ${darkMode ? 'text-white' : 'text-black'}`}
                                type="text"
                                placeholder="Quantity"
                                value={quantity}
                                // disabled={disabled}
                                onChange={(e) => setQuantity(e.target.value)}
                            />
    
                            <div className="text-gray-500 font-bold text-xs ml-1">{unitLabel}</div>
    
    
                            {/*// When price changes (in your select or other logic), ensure price updates are sent to parent.*/}
                        </div>
                        <div className={`absolute top-1 right-0`}>
                        <div className={`flex-none rounded-full p-1 ${disabled ? 'bg-red-500/40 animate-heartbeat' : 'bg-emerald-500/30 animate-rubberBand-delay'}`}>
                              <div className={`size-2 rounded-full ${disabled ? 'bg-red-400' : 'bg-emerald-500'}`} />
                            </div>
                        </div>
                    </div>
    
                    {/*U/M*/}
                    <div className={`relative ${accountLevel !== "DIST" ? 'col-span-1' : 'col-span-2'} py-2.5`}>
                        <div className={`border ${darkMode ? 'border-neutral-700' : ''} ${disabled ? 'border border-red-600 rounded-lg' : ''} flex flex-row rounded-lg h-full items-center justify-center hover:scale-y-105`}>
                            <Select
                                className={`p-1.5 rounded-md bg-transparent text-xs focus:outline-none ${darkMode ? 'text-white' : 'text-black'} w-full`}
                                onChange={handleVolumeChange}
                                value={selectedVolume}
                            >
                                {blankItem
                                    ? Object.entries(UMMapping).map(([um, label]) => (
                                        <option key={um} value={um}>
                                          {label}
                                        </option>
                                      ))
                                    : product?.prices.map((price, index) => {
                                        const label = UMMapping[price.um];
                                        return label ? (
                                          <option key={index} value={price.um}>
                                            {label}
                                          </option>
                                        ) : null;
                                      })}
    
                            </Select>
                        </div>
                        <div className={`absolute top-1 right-0`}>
                            <div className={`flex-none rounded-full p-1 ${disabled ? 'bg-red-500/40 animate-heartbeat' : 'bg-emerald-500/30 animate-rubberBand-delay'}`}>
                              <div className={`size-2 rounded-full ${disabled ? 'bg-red-400' : 'bg-emerald-500'}`} />
                            </div>
                        </div>
                    </div>
    
                    {/*Warehouse*/}
                    <div className={`relative col-span-1 py-2.5`}>
                        <div className={`border ${darkMode ? 'border-neutral-700' : ''} ${disabled ? 'border border-red-600 rounded-lg' : ''} flex flex-row rounded-lg h-full items-center justify-center hover:scale-y-105`}>
                            <Select
                                value={warehouse}
                                onChange={(e) => setWarehouse(e.target.value)}
                                className={`text-xs p-1.5 rounded-md bg-transparent focus:outline-none ${darkMode ? 'text-white' : 'text-black'} w-full`}
                            >
                                {/*{filteredWarehouses.map((option) => (*/}
                                {/*    <option key={option.value} value={option.value}>*/}
                                {/*        {option.label}*/}
                                {/*    </option>*/}
                                {/*))}*/}
                                
                                {(blankItem ? warehouseOptions : filteredWarehouses).map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                            </Select>
                        </div>
                        <div className={`absolute top-1 right-0`}>
                            <div
                                className={`flex-none rounded-full p-1 ${disabled ? 'bg-red-500/40 animate-heartbeat' : 'bg-emerald-500/30 animate-rubberBand-delay'}`}>
                                <div className={`size-2 rounded-full ${disabled ? 'bg-red-400' : 'bg-emerald-500'}`}/>
                            </div>
                        </div>
                    
                    </div>
                    
                    {/*Discount*/}
                    {accountLevel !== "DIST" && (
                        <div className={`relative col-span-1 py-2.5 h-full`}>
                            
                            <div className={`h-full`}>
                                <StepperInput
                                    value={discountAmount}
                                    onChange={(val) => handleDiscountChange({target: {value: val}})}
                                    step={0.5}
                                    placeholder="DISC"
                                    disabled={
                                        (initialDiscount > 0 || contract || isNoCharge || lock || accountLevel === "DIST" || ["GAL", "TR", "TON"].includes(selectedVolume)) &&
                                        accountLevel !== "CSR" &&
                                        accountLevel !== "D" &&
                                        accountLevel !== "A"
                                    }
                                />
                                
                                {/*{initialDiscount}*/}
                            </div>
                            
                            {/*{discountAmount}*/}
                            
                            <div className={`absolute top-1 right-0`}>
                                {isDiscountDisplayed && (
                                    <div
                                        className={`flex-none rounded-full p-1 ${disabled ? 'bg-red-500/40 animate-heartbeat' : 'bg-blue-500/30 animate-rubberBand-delay'}`}>
                                        <div
                                            className={`size-2 rounded-full ${disabled ? 'bg-red-400' : 'bg-blue-500'}`}/>
                                    </div>
                                )}
                            </div>
                            
                            {lock && (
                                <div className={`absolute top-1 right-0`}>
                                    <div className={`flex-none rounded-full animate-rubberBand-delay`}>
                                        <LockClosedIcon className={`size-4 stroke-2 rounded-full text-slate-500`}/>
                                    </div>
                                </div>
                            )}
                        
                        </div>
                    )}
                    
                    {/*No Charge*/}
                    <div className={`relative col-span-1 h-full flex items-center`}>
                        <fieldset>
                            <div className="flex items-center gap-1">
                                <div className="flex h-6 shrink-0 items-center">
                                    <div className="group grid size-4 grid-cols-1">
                                        <Input
                                            defaultChecked
                                            id="comments"
                                            name="comments"
                                            type="checkbox"
                                            checked={isNoCharge}
                                            onChange={handleCheckboxChange}
                                            aria-describedby="comments-description"
                                            className={`col-start-1 row-start-1 appearance-none rounded border ${darkMode ? 'bg-darkBgColor border-neutral-700' : 'bg-white border-gray-300'} checked:border-green-600 checked:bg-green-600 indeterminate:border-green-600 indeterminate:bg-green-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 disabled:border-green-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto`}
                                        />
                                        
                                        <svg
                                            fill="none"
                                            viewBox="0 0 14 14"
                                            className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
                                        >
                                            <path
                                                d="M3 8L6 11L11 3.5"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="opacity-0 group-has-[:checked]:opacity-100"
                                            />
                                            <path
                                                d="M3 7H11"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="opacity-0 group-has-[:indeterminate]:opacity-100"
                                            />
                                        </svg>
                                        
                                    </div>
                                </div>
                                <div className="text-xxs/6">
                                    
                                    {isNoCharge ? (
                                        <div className={`border ${darkMode ? 'border-neutral-700' : 'border bg-neutral-50'} ml-2 flex flex-row rounded-md h-full items-center justify-center hover:scale-y-105`}>
                                            <Select
                                                value={reasonCode} // Will display the code (e.g., JCNJ) after selection
                                                onChange={(e) => setReasonCode(e.target.value)} // Store the selected code in state
                                                className={`text-xxs p-1 rounded-sm bg-transparent focus:outline-none ${darkMode ? 'text-white' : 'text-black'} w-full`}
                                                // disabled={disabled}
                                            >
                                                <option value="DONATE">DONATE</option>
                                                <option value="R&DTAX">R&DTAX</option>
                                                <option value="REPLAC">REPLAC</option>
                                                <option value="TSTPRD">TSTPRD</option>
                                                <option value="N/A">N/A</option>
                                            </Select>
                                        </div>
                                    ) : (
                                        <label htmlFor="comments" className="font-medium">
                                            No Charge
                                        </label>
                                    )}
                                </div>
                            </div>
                        </fieldset>
                    </div>
    
    
                </div>
    
                {/*PRODUCT TOTAL*/}
                <div className="col-span-1 flex flex-row justify-end align-middle items-center">
                
                    <div className="ml-auto w-full flex flex-row justify-end">
                        
                        <div className={`flex flex-row mt-auto w-full mb-auto align-middle justify-end items-center ${disabled ? 'text-red-600' : ''} ${contract ? 'text-yellow-500' : (isDiscountDisplayed ? 'text-blue-600' : '')}`}>
                            <div className="text-md mr-3 font-light">$</div>
                            
                            <div className={`relative p-1.5`}>
                                
                                <div className={`text-md mr-3 font-bold tracking-wider`}>{numberWithCommas(calculateDiscountedTotal(state, total, early, prepay, 0))}</div>
                                {/*<div className={`text-md mr-3 font-bold tracking-wider`}>{numberWithCommas(total)}</div>*/}
                                
                                <div className={`absolute top-1 right-1`}>
                                    <div
                                        className={`flex-none rounded-full p-1 ${contract ? 'bg-yellow-500/30 animate-heartbeat' : (isDiscountDisplayed ? 'bg-blue-500/30 animate-heartbeat' : '')}`}>
                                        <div className={`size-2 rounded-full ${contract ? 'bg-yellow-500' : (isDiscountDisplayed ? 'bg-blue-500' : '')}`}/>
                                    </div>
                                </div>
                            
                            
                            </div>
                            <div className="text-borderColor text-sm">USD</div>
                            
                        </div>
                        
                        <Button onClick={() => setTankExpanded(!tankExpanded)} className={`mx-1.5 hover:scale-110 duration-500 ${priceType === "AG" ? '' : 'hidden'}`}>
                            <TANK className={`size-6 text-green-600 hover:animate-pulse`}/>
                        </Button>
                        
                        <Button className="rounded-full h-8 w-8 items-center justify-center align-middle"
                                disabled={!uniqueKey}
                                onClick={handleRemove}>
                            <TrashIcon className={`ml-1 size-5 text-gray-500 ${!uniqueKey ? 'text-red-800' : 'hover:text-red-600 hover:animate-pulse hover:scale-110'}`}/>
                        </Button>
                    </div>
                    
                </div>
                
            </div>
            
            {/*{contractPrices || "No Prices"}*/}
            
            
            {/* AG Tank Section */}
            
            {tankExpanded && (
                <div className={`space-y-3 py-3`}>
                    
                    {/*Tank Label Header*/}
                    <div className={`grid grid-cols-3 items-center`}>
                        
                        <div className={`col-span-1 flex items-center space-x-3`}>
                            {/*Tank Icons*/}
                            <div className={`size-12 bg-green-600/15 rounded-full flex items-center justify-center`}>
                                <TANK className={`text-green-600 size-8`}/>
                            </div>
                            
                            {/*Labels*/}
                            <div className={`flex flex-col`}>
                                <div className={`text-sm`}>Specify Tank Locations</div>
                                <div className={`text-xs text-gray-500`}>This is not limited to just tanks can include Barns, Tanks, Fields, etc.</div>
                            </div>
                        </div>
                        
                        {/*Tank Locations*/}
                        <div className={`col-span-2 relative p-1.5`}>
                            <label
                                className={`absolute flex -top-1 z-40 left-3 rounded-lg ${darkMode ? 'bg-darkMainColor' : 'bg-white'} px-1 text-xs font-medium`}
                            >
                                Tank Locations
                            </label>
                            
                            <Select
                                className={`block w-full px-4 focus:outline-green-600 border ${darkMode ? 'bg-darkMainColor text-white border-neutral-700' : 'bg-white'} rounded-md py-2`}
                                onChange={handleSelectChange}
                            >
                                <option value="">Select Tank Location...</option>
                                {Array.isArray(tankLocations) && tankLocations.length > 0 ? (
                                    tankLocations.map((location, index) => (
                                        <option key={index} value={location.label}>
                                            {location.label}
                                        </option>
                                    ))
                                ) : (
                                    <option disabled>No Tank locations available</option>
                                )}
                            </Select>
                        
                        
                        </div>
                    
                    </div>
                    
                    
                    
                    <div className={`grid grid-cols-1 gap-3`}>
                        
                        {tankLocals.length === 0 ? (
                            <div className="flex w-full h-full justify-center items-center py-2">
                                <div className={`flex items-center justify-center rounded-lg hover:scale-105`}>
                                    <div className="p-2 rounded-md shadow-gray-900 flex items-center justify-center flex-col m-2">
                                        <TANK className={`size-12 text-gray-500`}/>
                                        <p className="text-sm mt-2 line-clamp-1 flex">No Specified Locations</p>
                                        <p className="text-sm mt-1 line-clamp-1 flex text-gray-500">Choose a Location saved to the customers account from the dropdown above!</p>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            
                            <div className={`grid grid-cols-3 gap-3`}>
                                {tankLocals.map((tank, idx) => (
                                    <div key={idx} className={`col-span-1 divide-y rounded-lg border ${darkMode ? 'bg-darkMainColor border-neutral-700 divide-neutral-700' : 'bg-white divide-gray-200'} shadow-sm`}>
                                        <div className="relative flex w-full items-center justify-between space-x-6 px-8 py-2">
                                            <div className="flex-1 truncate">
                                                <div className="flex items-center space-x-3">
                                                    <h3 className="truncate text-sm font-medium">{tank.label}</h3>
                                                    <span className="inline-flex shrink-0 items-center rounded-full bg-green-600/15 px-1.5 py-0.5 text-xs font-medium text-green-700 ring-1 ring-green-600/20 ring-inset">{tank.type}</span>
                                                </div>
                                                {/*<p className="mt-1 truncate text-sm text-gray-500">{tank.position.lat.toFixed(2)}</p>*/}
                                            </div>
                                            
                                            <TANKIcons selectedTank={tank.type}/>
                                            
                                            
                                            <Button
                                                onClick={() => handleRemoveTank(tank.label)}
                                                className="absolute top-1 right-1 text-red-500 col-span-1 flex items-center justify-end"
                                            >
                                                <XCircleIcon className={`size-6 text-red-600`}/>
                                            </Button>
                                            
                                        </div>
                                        <div>
                                            <div className={`-mt-px flex divide-x ${darkMode ? 'divide-neutral-700' : 'divide-gray-200'}`}>
                                                <div className="flex w-0 flex-1">
                                                    <div className="relative -mr-px inline-flex w-0 px-3 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-1 text-sm font-semibold">
                                                        {/*<UMIcons selectedVolume={tank.unit}/>*/}
                                                        {/*{tank.quantity} {tank.unit}*/}
                                                        
                                                        <Input
                                                            className={`rounded-md bg-transparent text-sm focus:outline-none p-1.5 w-full ${darkMode ? 'text-white' : 'text-black'}`}
                                                            value={tank.quantity}
                                                            placeholder={`Desired Quantity`}
                                                            onChange={(e) => handleQuantityChange(tank.label, e.target.value)}
                                                        />
                                                        
                                                        <div className="text-gray-500 font-bold text-xs ml-1">{unitLabel}</div>
                                                        
                                                    </div>
                                                </div>
                                                <div className="-ml-px flex w-0 flex-1">
                                                    <div className="relative inline-flex w-0 px-3 flex-1 items-center justify-center gap-x-3 rounded-br-lg border border-transparent py-1 text-sm font-semibold">
                                                        <div className="text-gray-500 font-bold text-xs">Capacity</div>
                                                        
                                                        <div className={`rounded-md bg-transparent text-sm focus:outline-none p-1 ml-auto ${tank.quantity > tank.capacity ? 'text-red-600 animate-heartbeat' : ''}`}>{numberWithCommas(parseFloat(tank.capacity)) || "---"}</div>
                                                        
                                                        <div className="text-gray-500 font-bold text-xs ml-1">{tank.unit || "---"}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            
                        )}
                    
                    </div>
                
                </div>
            )}
            
            
            <Dialog open={priceLimited} onClose={setPriceLimited} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />
                
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className={`relative transform overflow-hidden rounded-lg ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                        >
                            <div className="sm:flex sm:items-start">
                                <div
                                    className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-600/15 sm:mx-0 sm:size-10">
                                    <ExclamationTriangleIcon aria-hidden="true" className="size-6 text-red-600"/>
                                </div>
                                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <DialogTitle as="h3" className="text-base font-semibold">
                          Price Limited Reached
                        </DialogTitle>
                        <div className="mt-2">
                            <p className="text-sm text-gray-500">
                                You are only able to set a maximum discount of 15% off of the original price.
                            </p>
                            
                            <div className="text-sm text-gray-500 mt-3">Original Price: ${numberWithCommas(parseFloat(orginalPrice).toFixed(2))}</div>
                            <div className="text-sm text-gray-500 mt-3">Maximum Discount: ${numberWithCommas(parseFloat(orginalPrice * 0.85).toFixed(2))}</div>

                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                      <Button
                        type="button"
                        onClick={() => setPriceLimited(false)}
                        className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                      >
                        I Understand
                      </Button>
                    </div>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>
            
            {/*Donate Confirm*/}
            <Dialog open={showConfirm} onClose={setShowConfirm} className="relative z-50">
              <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
              />
        
              <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <DialogPanel
                    transition
                    className={`relative transform overflow-hidden rounded-lg ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                  >
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-10">
                        <BanknotesIcon aria-hidden="true" className="size-6 text-green-600" />
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <DialogTitle as="h3" className="text-base font-semibold">
                          Confirm No Charge
                        </DialogTitle>
                        <div className="mt-2">
                            <p className="text-sm text-gray-500">
                                Are you sure you want to give this product with No Charge?
                            </p>
                            
                            
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                      <Button
                        type="button"
                        onClick={confirmCheck}
                        className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 sm:ml-3 sm:w-auto"
                      >
                        Confirm
                      </Button>
                      
                      <Button
                          type="button"
                          data-autofocus
                          onClick={cancelCheck}
                          className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                      >
                          Remove
                      </Button>
                    </div>
                  </DialogPanel>
                </div>
              </div>
            </Dialog>

            
        </div>
    )
}

export default ProductInput;
